export default __webpack_public_path__ + "static/media/pin.5e24c9c1.svg";